import { render } from "./TeamRules.vue?vue&type=template&id=0f94e37b"
import script from "./TeamRules.vue?vue&type=script&lang=js"
export * from "./TeamRules.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__